<template>
    <v-container fluid class="wide-frame-container">
      <v-row>
        <v-col>
          <Flap
            v-if="okFlap()"
            :menu="menu"
            :session="session"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :applicationName="applicationName"
            :customLanguage="customLanguage"
            @update-notification="updateNotification"
            @switch-language="switchLanguage"
            @user-interaction="userInteraction"
            ref="flapRef"
          />
          <Onboarding
            v-show="okOnboarding()"
            :menu="menu"
            :session="session"
            :environment="environment"
            :applicationName="applicationName"
            :generalExApplicationEx="generalExApplicationEx"
            :customLanguage="customLanguage"
            @go-home="goHome"
            @sel-menu="selMenu"
            ref="homeRef"
          />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import Flap from "./../transaction/Flap";
import Onboarding from "./Onboarding";

export default {
  name: "WideFrame",
  props: [
    "session",
    "menu",
    "environment",
    "generalExApplicationEx",
    "applicationName",
    "customLanguage",
  ],
  components: {
    Flap,
    Onboarding,
  },
  methods: {
    successLogin(data) {
      this.$emit("success-login", data);
    },
    clearLogin() {
      this.$emit("clear-login");
    },
    updated() {},
    goHome(applicationName, session) {
      this.$refs.homeRef.loadAll(applicationName, session);
    },
    callTransaction(getMenu) {
      this.$refs.flapRef.callFlap(getMenu);
    },
    updateNotification(data) {
      this.$emit("update-notification", data);
    },
    switchLanguage() {
      this.$emit("switch-language");
    },
    cleanData() {
      this.$refs.flapRef.cleanData();
    },
    selMenu(data) {
      this.$emit("sel-menu", data);
    },
    userInteraction(args) {
      this.$emit("user-interaction", args);
    },
    okFlap() {
      return this.session?.loggedIn;
    },
    okOnboarding() {
      return this.session?.loggedIn && !this.menu.selected;
    }
  },
};
</script>

<style scoped>
.wide-frame-container {
  width: 98%;
}
</style>

